import { render, staticRenderFns } from "./MethodMultibanco.vue?vue&type=template&id=225e836f&scoped=true&"
import script from "./MethodMultibanco.vue?vue&type=script&lang=js&"
export * from "./MethodMultibanco.vue?vue&type=script&lang=js&"
import style0 from "./MethodMultibanco.vue?vue&type=style&index=0&id=225e836f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225e836f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VRow})
